const beijingTime = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Asia/Shanghai',
  year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
})

export function isDateTimeField(key: string): boolean {
  return key.endsWith('_at') || key === 'as_of'
}

/** Default business dates use the company timezone, not the browser's UTC day. */
export function businessToday(now: Date = new Date()): string {
  const parts = Object.fromEntries(beijingTime.formatToParts(now).map(({ type, value }) => [type, value]))
  return `${parts.year}-${parts.month}-${parts.day}`
}

/** A presentation-only copy: audit snapshots keep their original API values. */
export function displaySnapshot(value: unknown): string | undefined {
  return JSON.stringify(value, (key, item) =>
    isDateTimeField(key) && typeof item === 'string' ? formatDateTime(item) : item, 2)
}

/** Display an API timestamp; never infer a timezone for dates or legacy naive values. */
export function formatDateTime(value: unknown): string {
  if (value === null || value === undefined || value === '') return '—'
  const original = String(value)
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/.test(original)) return original
  const date = new Date(original)
  if (Number.isNaN(date.getTime())) return original
  const parts = Object.fromEntries(beijingTime.formatToParts(date).map(({ type, value: part }) => [type, part]))
  return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}:${parts.second}`
}
